import { render, staticRenderFns } from "./AnswerSelect.vue?vue&type=template&id=0f469d7a&scoped=true&"
import script from "./AnswerSelect.vue?vue&type=script&lang=js&"
export * from "./AnswerSelect.vue?vue&type=script&lang=js&"
import style0 from "./AnswerSelect.vue?vue&type=style&index=0&id=0f469d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f469d7a",
  null
  
)

export default component.exports